export const GET_DATA_SELECTIONS      = "GET_DATA_SELECTIONS"
export const GET_DATA_SELECTIONS_SORT      = "GET_DATA_SELECTIONS_SORT"
